import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IcoEmojiInsatisfacao, IcoPaste, IcoShrink, IcoStar, Loading, Tab, PopoverCentralAjuda } from '../../../components'
import { useParams } from "react-router-dom";
import { history, numberAleatori } from '../../../helpers';

export default ({ nlsContexto, nls, imprimir }) => {
  const dispatch = useDispatch()
  const { IdSwot, idProjetos } = useParams()
  const { swots, loadSwots } = useSelector(state=> state.swotempresasState)
  const [IdSwotTab, setIdSwotTab] = useState('')

  const idarray = [216];

  // ✅ Mapeamento reverso para pegar o ID no formato original (Redux)
  const idSwotMappingReverse = {
    strength: 'forca',
    weakness: 'fraqueza',
    threat: 'ameaca',
    opportunity: 'oportunidade'
  }

  const idSwotOriginal = idSwotMappingReverse[IdSwot] || IdSwot

  useEffect(()=> {
    if (idSwotOriginal) { setIdSwotTab(idSwotOriginal) }
  }, [IdSwot])

  const handleSwot = (e) => {
    setIdSwotTab(e)

    const urlMapping = {
      forca: 'strength',
      fraqueza: 'weakness',
      ameaca: 'threat',
      oportunidade: 'opportunity'
    }

    const urlFinal = urlMapping[e] || e

    history.push(`/myprojects/${idProjetos}/swotanalysis/${urlFinal}`)
  }

  const labelsType = [ 'Satisfação geral', 'Insatisfação geral', 'Pilares', 'Indicadores' ]
  const swotIcon = (e) => {
    switch (e) {
      case 'Satisfação geral':
        return <IcoStar />;
      case 'Insatisfação geral':
        return <IcoEmojiInsatisfacao />;
      case 'Pilares':
        return <IcoPaste />;
      case 'Indicadores':
        return <IcoShrink />;
      default:
        return <IcoStar />;
    }
  }

  const tabContent = (e) => {
    const content = e?.map(tab=> {
      const swotsList = tab?.swot.map(swot=> {
        let swotDatab = swot.info
        if (typeof swot.info === 'string') {
          swotDatab = <div className='box-swot-content-info-list' data-cy='swot-item'>
              {swot.info.x? <span className='box-swot-content-info-list-loja'>{swot.info.x}</span>:null}
              <p>{swot.info}</p>
          </div>
        } else if ( typeof swot.info === 'object') {
          swotDatab = swot?.info.map(loja=> {
            return <div
  key={`tab-${tab.id}-swot${swot?.label}-loja-${loja}-${numberAleatori()}`}
  className='box-swot-content-info-list'
  data-cy='swot-item'
>
            {loja.x? <span className='box-swot-content-info-list-loja'>{loja.x}</span>:null}
              <p>{loja}</p>
            </div>
          })
        }
        return <div
  key={`tab-${tab.id}-swot${swot?.label}`}
  className='box-swot-content-info'
  data-cy='swot-section'
  data-cy-key={swot.id}
>
          <h3>{swotIcon(swot?.label)} {swot?.label}</h3>
            {swotDatab}
        </div>
      })

      return {
        id: tab.id,
        title: tab.title,
        content: (
          <div
  className="box-swot-content"
  data-cy='swot-dimension'
  data-cy-key={tab.id}
>
            <h2 className="box-swot-content-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {tab.title}
              <PopoverCentralAjuda cy='help' nlsContexto={nlsContexto} idarray={idarray} />
            </h2>
            {swotsList}
          </div>
        ),
      }
    })
    return content
  }
  
  if (!imprimir) {
    return (
      <div
  className="box-swot box-content box-swot-mensagem"
  data-cy='swot-result'
  data-cy-state='empty'
>
  <p data-cy='swot-empty'>{nls.semdadosparaexibir}</p>
</div>
    );
  }

  return loadSwots?
  <Loading type='element' title='' height='300px' />
:(
  <div
    className='box-swot'
    data-cy='swot-result'
    data-cy-state='ready'
  >
    <Tab
      cy='swot-tabs'
      actionTab={(e)=> handleSwot(e)}
      tabSelect={IdSwotTab}
      data={tabContent(swots)}
    />
  </div>
)
}
